<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="Salesforce向けVNコネクト設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer
        :initial-values="{
          routeAggregationAddressList:
            form.cloudVnConnectCommon!.routeAggregationAddressList &&
            form.cloudVnConnectCommon!.routeAggregationAddressList.length > 0
              ? form.cloudVnConnectCommon!.routeAggregationAddressList
              : [''],
        }"
        v-slot="{ handleSubmit }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- クラウド設定 -->
                <v-row>
                  <v-col>
                    <h3>クラウド設定</h3>
                  </v-col>
                </v-row>
                <!--ロケーション-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ロケーション"
                      :is-info="false"
                      :is-required="false"
                    />
                    <app-form-input v-if="isAdd" value="東日本" disabled />
                    <app-form-input
                      v-else
                      :value="
                        $filter.enumTo(
                          cloudVnSfdcDetail!.cloudVnConnectCommon.location,
                          'location'
                        )
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--接続先仮想ネットワーク(VPN/VN)名-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="接続先仮想ネットワーク(VPN/VN)名"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="selectedVpnVn"
                        label="接続先仮想ネットワーク(VPN/VN)名"
                        v-model="selectedVpnVn"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select-search
                          :items="vpnVnCodeSelectList"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <!--変更の場合、変更不可-->
                    <app-form-input v-else :value="vpnVnName" disabled />
                  </v-col>
                </v-row>

                <!-- VNコネクト設定 -->
                <v-row>
                  <v-col>
                    <h3>VNコネクト設定</h3>
                  </v-col>
                </v-row>
                <!--品目-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="品目"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <validation-provider
                      name="bandwidth"
                      label="品目"
                      v-model="
                        (form as CloudVnSfdcPost).cloudVnConnectCommon!
                          .bandwidth
                      "
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                      v-if="isAdd"
                    >
                      <app-select
                        :items="bandwidthSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                    <app-form-input
                      v-else
                      disabled
                      :value="
                        $filter.bandwidthTo(
                          cloudVnSfdcDetail!.cloudVnConnectCommon.bandwidth
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--VNコネクト名(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Act)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-required="!isVnConnectNameActDisable"
                      :is-info="!isVnConnectNameActDisable"
                    />
                    <validation-provider
                      name="vnConnectNameAct"
                      label="VNコネクト名(Act)"
                      v-model="form.cloudVnConnectAct.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="isVnConnectNameActDisable"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Sby)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-required="!isVnConnectNameSbyDisable"
                      :is-info="!isVnConnectNameSbyDisable"
                    />
                    <validation-provider
                      name="vnConnectNameSby"
                      label="VNコネクト名(Sby)"
                      v-model="form.cloudVnConnectSby.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="isVnConnectNameSbyDisable"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(共通) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(共通)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group label="ルーティング種別" value="BGP4" />
                  </v-col>
                </v-row>
                <!--AS番号-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="AS番号"
                      :msg="
                        $filter.message(`info_as_number`, {
                          numberArray: `2～8073、8076～9995、9997～12075、12077～23455、23457～64495、64512～64949、64970～65501、65504～65514、65521～65534`,
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="asNumber"
                      label="AS番号"
                      v-model.number="
                        (form as CloudVnSfdcPost).cloudVnConnectAct.asNumber
                      "
                      :rules="{
                        required: true,
                        numeric: true,
                        is_number_range: {
                          range:
                            '2-8073,8076-9995,9997-12075,12077-23455,23457-64495,64512-64949,64970-65501,65504-65514,65521-65534',
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :disabled="!isAdd"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Maximum Prefix(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Maximum Prefix"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="maximumPrefix"
                      label="Maximum Prefix(Act)"
                      v-model="form.cloudVnConnectAct.maximumPrefix"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="maximumPrefixSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Act) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="wanAddressAct"
                      label="WANアドレス(Act)"
                      v-model="
                        (form as CloudVnSfdcPost).cloudVnConnectAct.wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { eq: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressAct"
                      label="ピアIPアドレス(Act)"
                      v-model="
                        (form as CloudVnSfdcPost).cloudVnConnectAct
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnSfdcPost).cloudVnConnectAct
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnSfdcPost).cloudVnConnectAct
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnSfdcPost).cloudVnConnectAct
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnSfdcPost).cloudVnConnectAct
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('HIGH_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('LOW_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Sby) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-required="isAdd"
                      :is-info="isAdd"
                    />
                    <validation-provider
                      name="wanAddressSby"
                      label="WANアドレス(Sby)"
                      v-model="
                        (form as CloudVnSfdcPost).cloudVnConnectSby.wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { eq: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-required="isAdd"
                      :is-info="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressSby"
                      label="ピアIPアドレス(Sby)"
                      v-model="
                        (form as CloudVnSfdcPost).cloudVnConnectSby
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnSfdcPost).cloudVnConnectSby
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnSfdcPost).cloudVnConnectSby
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnSfdcPost).cloudVnConnectSby
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnSfdcPost).cloudVnConnectSby
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('LOW_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('HIGH_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- カスタム経路集約情報 -->
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="経路集約"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.cloudVnConnectCommon.routeAggregation"
                      hide-details
                      inline
                    >
                      <v-radio
                        v-for="(routeOption, index) in routeOptions"
                        :key="`${routeOption.text + index}`"
                        :label="routeOption.text"
                        :value="routeOption.value"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <!--経路集約アドレス-->
                <v-row
                  v-if="form.cloudVnConnectCommon.routeAggregation !== 'OFF'"
                >
                  <v-col>
                    <app-badge
                      item="経路集約アドレス"
                      :is-required="
                        form.cloudVnConnectCommon.routeAggregation === 'CUSTOM'
                      "
                      :is-info="
                        form.cloudVnConnectCommon.routeAggregation === 'CUSTOM'
                      "
                      :msg="$filter.message('info_routing_address')"
                    />
                    <template
                      v-if="form.cloudVnConnectCommon.routeAggregation === 'ON'"
                    >
                      <span class="ml-3">0.0.0.0/0</span>
                    </template>
                    <template
                      v-if="
                        form.cloudVnConnectCommon.routeAggregation === 'CUSTOM'
                      "
                    >
                      <validation-array
                        name="routeAggregationAddressList"
                        v-slot="{ fields, push, remove }"
                      >
                        <template
                          v-for="(item, index) in fields"
                          :key="item.key"
                        >
                          <v-row class="ga-2">
                            <validation-provider
                              :name="`routingIp_${item.key}`"
                              label="経路集約アドレス"
                              v-model="
                                form.cloudVnConnectCommon!
                                  .routeAggregationAddressList![index]
                              "
                              :rules="{
                                required: true,
                                is_ip_subnet: { min: 1, max: 30 },
                                is_network_address: true,
                                is_not_default_root: true,
                                duplicate: { list: routingAddressList(index) },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                class="ml-1"
                                :placeholder="
                                  $filter.message(
                                    'placeholder_ip_address_with_subnet24'
                                  )
                                "
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                              <v-btn
                                icon="$mdiMinus"
                                size="small"
                                variant="outlined"
                                class="rounded-sm ml-2 mr-3"
                                @click="removeRouteAddress(index, remove)"
                              />
                            </validation-provider>
                          </v-row>
                        </template>
                        <!--経路集約アドレス追加-CUSTOMのみ表示-->
                        <v-row justify="end">
                          <v-btn
                            icon="$mdiPlus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm ml-2 mr-3"
                            :disabled="currentLength >= 100"
                            @click="addRouteAddress(push)"
                          />
                        </v-row>
                      </validation-array>
                    </template>
                  </v-col>
                </v-row>

                <!-- NAPT設定 -->
                <v-row>
                  <v-col>
                    <h3>NAPT設定</h3>
                  </v-col>
                </v-row>
                <!--払い出しグローバルIPアドレス個数-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="払い出しグローバルIPアドレス個数"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="addNaptNum"
                        label="払い出しグローバルIPアドレス個数"
                        v-model="
                          (form as CloudVnSfdcPost).cloudVnConnectCommon
                            .addNaptNum
                        "
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select
                          :items="globalIpCountOptions"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        cloudVnSfdcDetail!.cloudVnConnectCommon
                          .naptGlobalIpTotal
                      "
                      disabled
                    />
                  </v-col>
                </v-row>

                <!--備考-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="備考"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :is-info="true"
                      :isRequired="false"
                    />
                    <validation-provider
                      name="description"
                      label="備考"
                      v-model="form.cloudVnConnectCommon.description"
                      :rules="{ max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  isAdd ? "追加" : "変更"
                }}</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type {
  BandWidth,
  RouteAggregation,
  VpnVnCode as CloudVpnVnCode,
} from "@/apis/CloudVnMsApi";
import type { CloudLine } from "@/apis/CloudLineApi";
import cloneDeep from "lodash/cloneDeep";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";
import type {
  CloudVnSfdcActSby,
  CloudVnSfdcDetail,
  CloudVnSfdcPost,
  CloudVnSfdcPut,
  SfdcVpnVnCodeGetRes,
} from "@/apis/CloudVnSfdcApi";
import MultiCloudSfdcVnConnectionConfirm from "@/modals/multicloud/salesforce/MultiCloudSfdcVnConnectionConfirm.vue";

export default defineComponent({
  name: "MultiCloudSfdcVnLineEdit",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    // 変更の場合用
    cloudVnSfdcDetail: {
      type: Object as PropType<CloudVnSfdcDetail>,
      default: undefined,
    },
    // 追加の場合用
    cloudVnSfdcKeyId: {
      type: String as PropType<string>,
      default: undefined,
    },
    remainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form: CloudVnSfdcPost | CloudVnSfdcPut = (() => {
      if (this.cloudVnSfdcDetail) {
        // 変更
        const cloudVnSfdcDetailCopy = cloneDeep(this.cloudVnSfdcDetail);
        // 経路集約アドレスを数値昇順でソート
        if (
          cloudVnSfdcDetailCopy.cloudVnConnectCommon &&
          Array.isArray(
            cloudVnSfdcDetailCopy.cloudVnConnectCommon
              .routeAggregationAddressList
          )
        ) {
          cloudVnSfdcDetailCopy.cloudVnConnectCommon.routeAggregationAddressList =
            cloudVnSfdcDetailCopy.cloudVnConnectCommon.routeAggregationAddressList.sortIpAddress();
        }
        const form: CloudVnSfdcPut = {
          cloudVnConnectCommon: cloudVnSfdcDetailCopy.cloudVnConnectCommon,
          cloudVnConnectAct: cloudVnSfdcDetailCopy.cloudVnConnectAct,
          cloudVnConnectSby: cloudVnSfdcDetailCopy.cloudVnConnectSby
            ? cloudVnSfdcDetailCopy.cloudVnConnectSby
            : ({ maximumPrefix: 100 } as CloudVnSfdcPut["cloudVnConnectSby"]),
          note: null,
          cloudVnSfdcKeyId: cloudVnSfdcDetailCopy.cloudVnSfdcKeyId,
        };
        return form;
      } else {
        // 追加
        const form: CloudVnSfdcPost = {
          cloudVnConnectCommon: {
            bandwidthType: "PF",
            routeAggregation: "OFF",
            routeAggregationAddressList: [""],
            addNaptNum: 1,
            description: null,
          } as CloudVnSfdcPost["cloudVnConnectCommon"],
          cloudVnConnectAct: {
            maximumPrefix: 100,
          } as CloudVnSfdcPost["cloudVnConnectAct"],
          cloudVnConnectSby: {
            maximumPrefix: 100,
          } as CloudVnSfdcPost["cloudVnConnectSby"],
          note: null,
          cloudVnSfdcKeyId: this.cloudVnSfdcKeyId!,
        };
        return form;
      }
    })();

    return {
      form: form,
      isLoaded: false,
      vpnVnCodeList: [] as SfdcVpnVnCodeGetRes["cloudVnConnectsList"],
      cloudLineMaxBandwidth: {} as CloudLine["bandwidth"],
      selectedVpnVn: null as null | CloudVpnVnCode,
      bandwidthOptions: [
        { text: "10Mbps", value: { value: 10, unit: "MBPS" } },
        { text: "20Mbps", value: { value: 20, unit: "MBPS" } },
        { text: "30Mbps", value: { value: 30, unit: "MBPS" } },
        { text: "40Mbps", value: { value: 40, unit: "MBPS" } },
        { text: "50Mbps", value: { value: 50, unit: "MBPS" } },
        { text: "60Mbps", value: { value: 60, unit: "MBPS" } },
        { text: "70Mbps", value: { value: 70, unit: "MBPS" } },
        { text: "80Mbps", value: { value: 80, unit: "MBPS" } },
        { text: "90Mbps", value: { value: 90, unit: "MBPS" } },
        { text: "100Mbps", value: { value: 100, unit: "MBPS" } },
        { text: "200Mbps", value: { value: 200, unit: "MBPS" } },
        { text: "300Mbps", value: { value: 300, unit: "MBPS" } },
        { text: "400Mbps", value: { value: 400, unit: "MBPS" } },
        { text: "500Mbps", value: { value: 500, unit: "MBPS" } },
        { text: "600Mbps", value: { value: 600, unit: "MBPS" } },
        { text: "700Mbps", value: { value: 700, unit: "MBPS" } },
        { text: "800Mbps", value: { value: 800, unit: "MBPS" } },
        { text: "900Mbps", value: { value: 900, unit: "MBPS" } },
        { text: "1Gbps", value: { value: 1, unit: "GBPS" } },
        { text: "2Gbps", value: { value: 2, unit: "GBPS" } },
        { text: "3Gbps", value: { value: 3, unit: "GBPS" } },
        { text: "4Gbps", value: { value: 4, unit: "GBPS" } },
        { text: "5Gbps", value: { value: 5, unit: "GBPS" } },
        { text: "6Gbps", value: { value: 6, unit: "GBPS" } },
        { text: "7Gbps", value: { value: 7, unit: "GBPS" } },
        { text: "8Gbps", value: { value: 8, unit: "GBPS" } },
        { text: "9Gbps", value: { value: 9, unit: "GBPS" } },
        { text: "10Gbps", value: { value: 10, unit: "GBPS" } },
      ] as { text: string; value: BandWidth }[],
      routeOptions: [
        { value: "ON", text: "ON" },
        { value: "OFF", text: "OFF" },
        { value: "CUSTOM", text: "CUSTOM" },
      ],
      /** Maximum Prefix上限値(変更の場合用) */
      maximumPrefixLimit: null as UpperLimitEntity | null,
      /** 1G超VNコネクト */
      vnConnects1G: null as UpperLimitEntity | null,
      upperLimitNaptMap: {} as Record<string, number>,
      editRemainingBandwidth: 0 as number | null,
    };
  },
  computed: {
    /** VNコネクト(Act)名編集可否 */
    isVnConnectNameActDisable(): boolean {
      return (
        !this.isAdd &&
        this.cloudVnSfdcDetail!.cloudVnConnectAct.isVnConnectStatus
      );
    },
    /** VNコネクト(Sby)名編集可否 */
    isVnConnectNameSbyDisable(): boolean {
      return (
        !this.isAdd &&
        this.cloudVnSfdcDetail!.cloudVnConnectSby.isVnConnectStatus
      );
    },
    /** 払い出しグローバルIP個数(プルダウン) */
    globalIpCountOptions(): number[] {
      const ADD_NAPT_NUM_MIN = 1;
      const ADD_NAPT_NUM_MAX = 5;
      if (!this.selectedVpnVn) {
        return Array.range(ADD_NAPT_NUM_MIN, ADD_NAPT_NUM_MAX + 1);
      } else {
        const naptUpperLimit = this.upperLimitNaptMap[this.selectedVpnVn];
        return Array.range(ADD_NAPT_NUM_MIN, naptUpperLimit + 1);
      }
    },
    currentLength(): number {
      return this.form.cloudVnConnectCommon!.routeAggregationAddressList
        ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.length
        : 0;
    },
    /** true: 新規, false: 変更 */
    isAdd(): boolean {
      return !this.cloudVnSfdcDetail;
    },

    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vpnVnCode.startsWith("D")) {
          return {
            value: v.vpnVnCode,
            text: v.vnName + ":" + v.vpnVnCode + "(L3)",
          };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
    /** 品目の選択肢 */
    bandwidthSelectList(): { text: string; value: BandWidth }[] {
      // クラウド帯域値
      const limit1 = this.$filter.bandwidthToBps(this.cloudLineMaxBandwidth);
      // 1G超VNコネクト
      const limit2 = this.$filter.bandwidthToBps({
        value: this.vnConnects1G!.upperLimit,
        unit: "GBPS",
      });
      return this.bandwidthOptions.filter((v) => {
        const bps = this.$filter.bandwidthToBps(v.value)!;
        return (
          bps <= limit1! &&
          bps <= limit2! &&
          bps <= this.editRemainingBandwidth!
        );
      });
    },
    /** Maximum Prefixの選択肢 */
    maximumPrefixSelectList(): { text: string; value: number }[] {
      if (this.isAdd) {
        return [{ value: 100, text: "100" }];
      } else {
        return [
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 300, text: "300" },
          { value: 400, text: "400" },
          { value: 500, text: "500" },
          { value: 1000, text: "1000" },
          { value: 1500, text: "1500" },
          { value: 2000, text: "2000" },
        ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
      }
    },

    vpnVnName(): string | null {
      if (this.isAdd) return null;
      if (
        this.cloudVnSfdcDetail!.cloudVnConnectCommon.vpnVnCode.startsWith("D")
      ) {
        return (
          this.cloudVnSfdcDetail!.cloudVnConnectCommon.vnName +
          ":" +
          this.cloudVnSfdcDetail!.cloudVnConnectCommon.vpnVnCode +
          "(" +
          this.cloudVnSfdcDetail!.cloudVnConnectCommon.vnType +
          ")"
        );
      } else {
        return this.cloudVnSfdcDetail!.cloudVnConnectCommon.vpnVnCode;
      }
    },
    /** 経路集約アドレスの重複チェック用リスト作成 */
    routingAddressList() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.routeAggregationAddressList
          ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
  },
  watch: {
    /** 経路集約がCUSTOMに変更されて初期値が存在しない場合は初期化 */
    "form.cloudVnConnectCommon.routeAggregation"(newValue: RouteAggregation) {
      if (
        newValue === "CUSTOM" &&
        (!this.form.cloudVnConnectCommon!.routeAggregationAddressList ||
          this.form.cloudVnConnectCommon!.routeAggregationAddressList.length ===
            0)
      ) {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },
    /** グローバルIP個数がNAPTの最大値を上回る場合、グローバルIP個数をnullにする */
    globalIpCountOptions(newVal: number[]) {
      if (!this.isAdd) return;
      const max = Math.max(...newVal);
      const postForm = this.form as CloudVnSfdcPost;
      if (postForm.cloudVnConnectCommon.addNaptNum > max) {
        (postForm.cloudVnConnectCommon.addNaptNum as null | number) = null;
      }
    },
  },
  async mounted() {
    this.maxBandwidth();
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      if (this.isAdd) {
        // 回線情報に紐づくクラウド回線情報を取得APIを呼び出す
        const lines = (await this.$api.cloudLine.getCloudLines()).lineList;
        const cloudLines = lines.flatMap((v) => v.cloudLineList);
        // クラウド回線の帯域最大値(品目の上限値制御用)
        this.cloudLineMaxBandwidth = cloudLines.find(
          (v: { cloudLineSeq: string }) => v.cloudLineSeq === this.cloudLineSeq
        )!.bandwidth;

        // 1G超VNコネクトの値を取得（品目の上限値制御用）
        this.vnConnects1G = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "MULTI_CLOUD",
            cloudLineSeq: this.cloudLineSeq,
          })
        ).cloudLine!.upperLimitList!.find(
          (v: { upperLimitItemName: string }) =>
            v.upperLimitItemName === "1G超VNコネクト"
        )!;

        this.vpnVnCodeList = (
          await this.$api.cloudVnSfdc.getVpnVnCodes()
        ).sortBy(["vpnVnCode", "asc"]);

        const saasServiceList = (await this.$api.saas.getAll()).saasServiceList;
        this.upperLimitNaptMap = saasServiceList
          .filter(
            (saasService) => saasService.sfdcInfo && saasService.sfdcInfo.sfdc
          )
          .toMap(
            (v) => v.saasCommon.vpnVnCode,
            (v) => v.sfdcInfo!.sfdc!.upperLimitNapt
          );
      } else {
        // maximumPrefixの上限値を取得
        this.maximumPrefixLimit = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "MULTI_CLOUD",
            cloudLineSeq: this.cloudLineSeq,
            wnumber: this.cloudVnSfdcDetail!.cloudVnConnectAct.wnumber,
          })
        ).cloudLine!.upperLimitList!.find(
          (v: { upperLimitItemName: string }) =>
            v.upperLimitItemName === "BGP4の最大経路数"
        )!;
      }
    },

    /** 設定可能帯域の算出 */
    maxBandwidth() {
      if (this.isAdd) {
        // 追加の場合、設定可能帯域をそのまま利用
        return (this.editRemainingBandwidth = this.remainingBandwidth)!;
      }
    },

    /** 経路集約アドレス削除 */
    removeRouteAddress(index: number, remove: (idx: number) => void) {
      const list = this.form.cloudVnConnectCommon!.routeAggregationAddressList!;
      if (list.length > 1) {
        list.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },

    /** 経路集約アドレス追加 */
    addRouteAddress(push: (item: any) => void) {
      const addItem = "";
      this.form.cloudVnConnectCommon!.routeAggregationAddressList = [
        ...this.form.cloudVnConnectCommon!.routeAggregationAddressList!,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    async submit() {
      const form = {
        ...this.form,
        cloudVnConnectCommon: {
          ...this.form.cloudVnConnectCommon,
          routeAggregationAddressList:
            this.form.cloudVnConnectCommon!.routeAggregation === "CUSTOM"
              ? this.form.cloudVnConnectCommon!.routeAggregationAddressList
              : null,
        },
      } as
        | CloudVnSfdcPost
        | (CloudVnSfdcPut & {
            cloudVnConnectSby: Pick<CloudVnSfdcActSby, "asNumber">;
            cloudVnConnectAct: Pick<CloudVnSfdcActSby, "asNumber">;
          });
      //AS番号(act)の値をAS番号(sby)に代入する
      form.cloudVnConnectSby!.asNumber = form.cloudVnConnectAct!.asNumber;
      if (this.isAdd) {
        const postForm = form as CloudVnSfdcPost;
        postForm.cloudVnConnectCommon.vpnVnCode = this.selectedVpnVn!;
        const vnName = this.vpnVnCodeList.find(
          (v) => v.vpnVnCode === postForm.cloudVnConnectCommon.vpnVnCode
        )!.vnName;

        await this.$modal.show(MultiCloudSfdcVnConnectionConfirm, {
          cloudVnSfdcDetail: {
            cloudVnConnectCommon: {
              location: "EAST_JAPAN",
              naptGlobalIpTotal: postForm.cloudVnConnectCommon.addNaptNum,
              vnName,
              routingType: "BGP4",
              ...postForm.cloudVnConnectCommon,
            },
            cloudVnConnectAct: {
              ...postForm.cloudVnConnectAct,
              localPreference: "HIGH_PRIORITY",
              med: "LOW_PRIORITY",
            },
            cloudVnConnectSby: {
              ...postForm.cloudVnConnectSby,
              localPreference: "LOW_PRIORITY",
              med: "HIGH_PRIORITY",
            },
          },
          displayType: "A",
        });

        await this.$api.cloudVnSfdc.postVnConnect(this.cloudLineSeq, postForm);
        await (
          this.$refs.modal as typeof VueFinalModal & { ok: () => void }
        ).ok();
      } else {
        form.cloudVnConnectSby.maximumPrefix =
          form.cloudVnConnectAct.maximumPrefix;

        await this.$modal.show(MultiCloudSfdcVnConnectionConfirm, {
          cloudVnSfdcDetail: form,
          displayType: "M",
        });

        await this.$api.cloudVnSfdc.putVnConnect(
          this.cloudLineSeq,
          this.cloudVnSfdcDetail!.cloudVnConnectAct.wnumber,
          form as CloudVnSfdcPut
        );

        await (
          this.$refs.modal as typeof VueFinalModal & { ok: () => void }
        ).ok();
      }
    },
  },
});
</script>
